import React from 'react';
import { Box, Icon, Text, HStack, VStack } from '@chakra-ui/react';

interface IconTextCardProps {
    icon: React.ElementType;
    label: string;
    caption?: string;
    fontSize?: string;
    onClick: () => void;
    disabled?: boolean;
}

const IconTextCard: React.FC<IconTextCardProps> = ({ icon, label, caption, fontSize, onClick, disabled }) => {
    return (
        <Box
            as="button"
            onClick={disabled ? undefined : onClick}
            p={4}
            bg={disabled ? 'gray.300' : 'yellow.600'}
            _hover={disabled ? {} : { bg: 'yellow.700' }}
            transition="background-color 0.2s"
            cursor={disabled ? 'not-allowed' : 'pointer'}
            w="full"
            opacity={disabled ? 0.7 : 1}
        >
            <HStack gap={4} align="center">
                {/* Иконка слева */}
                <Icon as={icon} boxSize={10} color="black" flexShrink={0} />
                {/* Текст справа */}
                <VStack align="start" gap={0} ml={2} flex={1} minW={0}>
                    <Text fontSize={fontSize || 'lg'} fontWeight="400" color="black" textAlign="left">
                        {label}
                    </Text>
                    {caption && (
                        <Text fontSize="sm" color="gray.600" textAlign="left">
                            {caption}
                        </Text>
                    )}
                </VStack>
            </HStack>
        </Box>
    );
};

export default IconTextCard;
